import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class IncidentPendingReportService extends Service{
    constructor() {
        super();
        this.baseURL = 'incidentPendingReport';
    }

    findPendingIncidentByStartDateAndEndDate(dateStart,dateEnd) {
        return fetch(SERVER_URL + this.baseURL + '/findPendingIncidentByStartDateAndEndDate/'+dateStart+'/'+dateEnd, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}